'use client'

import { useEffect } from 'react'
import { subPath } from '@constants/paths'

export function ServiceWorkerProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Only register service worker in production or if explicitly enabled
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_ENABLE_SW === 'true') {
      if ('serviceWorker' in navigator) {
        const swUrl = `/${subPath}/serwist/sw.js`

        navigator.serviceWorker
          .register(swUrl, {
            scope: `/${subPath}/`,
          })
          .then((registration) => {
            console.log('Service Worker registered successfully:', registration.scope)
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error)
          })
      }
    }
  }, [])

  return <>{children}</>
}
